import React, { Component } from 'react'
import Checkbox from 'react-mdl/lib/Checkbox'
import styled from 'styled-components'
import { Textfield } from 'react-mdl'

const ModelAnswerContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`

const StyledCheckbox = styled(Checkbox)`
    transform: scale(2);
    width: 50px;
    margin-top: 25px;
    margin-left: 25px;
`
const StyledTextfield = styled(Textfield)`
  width: 100%;
`
class CheckboxAnswer extends React.Component {
    onChange = newState => {
      console.log('CheckboxAnswer new state', newState);
      this.props.onChange(newState)
    }
    handleCheckboxClick = (checked) => {
        this.props.state.isAnswer = checked
        console.log('checkbox click', this.props.state);
        this.onChange(this.props.state)
    }
    handleTextChange =   ({ target: { name, value } })=> {
        this.props.state.text = value;
        console.log('text change', value, this.props.state);
        this.onChange(this.props.state)
    }
    render() {
      const {
        state,
        ...restProps
      } = this.props

      return (
        <ModelAnswerContainer >
                <StyledCheckbox
                    onChange={e => this.handleCheckboxClick(e.target.checked)}
                    checked={state.isAnswer}
                />
                <StyledTextfield
                    required
                    name="title"
                    label="Answer Text"
                    value={state.text}
                    onChange={this.handleTextChange}
                />
        </ModelAnswerContainer>
      )
    }
  }

export default CheckboxAnswer


// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/CheckboxAnswer.js